import { useQuery } from 'react-query';

import { checklistTemplateApi } from 'src/Services/API';

const ONE_HOUR_MS = 60 * 60 * 1000;

const useChecklistTemplates = () => {
  return useQuery({
    queryKey: ['fetch-checklist-templates'],
    queryFn: () => checklistTemplateApi.findAll(),
    staleTime: ONE_HOUR_MS,
    cacheTime: ONE_HOUR_MS * 2,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export default useChecklistTemplates;
